import { componentSizes } from '@/theme/componentSizes';
import { s, tableTokens, typographyTokens } from '../../theme/tokens';
import { Box } from './Box';
import { Skeleton } from './Skeleton';
import type { ReactNode } from 'react';

export const DATA_GRID_EMPTY_STATE_NO_DATA_LABEL = 'No data';

export const DataGridEmptyState = ({
  title,
  body,
  action,
  variant = 'metricCard',
}: {
  title: string;
  body?: string;
  action?: ReactNode;
  variant?: 'default' | 'metricCard';
}): JSX.Element => (
  <Box
    sx={{
      padding: s('xl'),
      textAlign: 'center',
      color: 'text.secondary',
      display: 'flex',
      flexDirection: 'column',
      gap: s('sm'),
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: componentSizes.dataGrid.stateMinHeight,
      height: '100%',
      width: '100%',
    }}
  >
    <Box
      sx={
        variant === 'metricCard'
          ? {
              color: 'text.secondary',
              fontSize: { xs: 16, xl: 18 },
              fontWeight: typographyTokens.body.fontWeight,
              fontVariantNumeric: 'tabular-nums',
              lineHeight: 1.15,
            }
          : { fontSize: '14px', fontWeight: 400, lineHeight: 1.4 }
      }
    >
      {title}
    </Box>
    {body ? <Box sx={{ fontSize: '14px', lineHeight: 1.4 }}>{body}</Box> : null}
    {action ? <Box>{action}</Box> : null}
  </Box>
);

export const DataGridLoadingState = ({
  label = 'Loading',
  rowCount = 6,
}: {
  label?: string;
  rowCount?: number;
}): JSX.Element => (
  <Box
    aria-label={`${label}...`}
    sx={{
      paddingY: s('lg'),
      paddingX: s('xl'),
      display: 'grid',
      gap: s('sm'),
      minHeight: componentSizes.dataGrid.stateMinHeight,
      alignContent: 'center',
    }}
  >
    {Array.from({ length: rowCount }).map((_value, index) => (
      <Box
        key={`grid-loading-row-${index}`}
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: s(tableTokens.cellPadding.y),
        }}
      >
        <Skeleton height={componentSizes.dataGrid.skeletonHeight} width="100%" variant="text" />
      </Box>
    ))}
  </Box>
);
